import { RootState } from '@app/model';

export const selectIsLoading = ({ aven: { isLoading } }: RootState) => isLoading;
export const selectIsCoinsLoading = ({ aven: { isCoinsLoading } }: RootState) => isCoinsLoading;
export const selectAvenResults = ({ aven: { results } }: RootState) => results;
export const selectCurrentSavedResults = ({ aven: { currentSavedResults } }: RootState) => currentSavedResults;
